import * as React from "react";
import browserImageSize from "browser-image-size";

type Props = {
  image: string;
};

export default function SvgComponent(props: Props) {
  const { image } = props;
  const [size, setSize] = React.useState<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });

  React.useEffect(() => {
    async function f() {
      const s = await browserImageSize(image);
      setSize(s);
    }
    if (image) {
      f();
    } else {
      setSize({ width: 10, height: 10 });
    }
  }, [image]);
  return (
    <>
      <svg width={374} height={74} viewBox="0 0 374 74" fill="none" {...props}>
        <g clipPath="url(#prefix__clip0)">
          <path d="M374 .048H0v74h374v-74z" fill="#00618F" />
          <path d="M64 74V0h1.995v74H64z" fill="#002C51" />
          <path d="M63.997.06H0V74h63.997V.06z" fill="#D1BB91" />
          <path
            d="M63.197 9.323H1.66v9.229h61.536V9.323z"
            fill="url(#prefix__paint0_linear)"
          />
          <path d="M63.197.078H1.66v9.229h61.536V.077z" fill="#E2D5B0" />
          <path d="M63.197 18.565H1.66v9.229h61.536v-9.23z" fill="#D1BB91" />
          <path
            d="M63.197 27.807H1.66v9.229h61.536v-9.23z"
            fill="url(#prefix__paint1_linear)"
          />
          <path d="M63.197 37.049H1.66v9.228h61.536V37.05z" fill="#E2D5B0" />
          <path
            d="M63.197 46.29H1.66v9.23h61.536v-9.23z"
            fill="url(#prefix__paint2_linear)"
          />
          <path d="M63.197 64.751H1.66v9.229h61.536v-9.229z" fill="#E2D5B0" />
          <path d="M64 0h-4.923v73.94H64V0z" fill="#E2D5B0" />
          <path d="M59.077 73.94V0" stroke="#FFFCDB" />
          <path d="M4.928.031H.005v73.94h4.923V.03z" fill="#D7C6A6" />
          <path d="M4.928.031v73.94" stroke="#805D3A" />
          <image
            id="prefix__image0"
            x="130"
            y="2"
            width={size.width}
            height={size.height}
            href={image}
            xlinkHref={image}
            transform="scale(.5 .5)"
          />
        </g>
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={2.022}
            y1={13.938}
            x2={63.675}
            y2={13.938}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C1AA7D" />
            <stop offset={0.263} stopColor="#DECCA8" />
            <stop offset={0.721} stopColor="#DECCA8" />
            <stop offset={1} stopColor="#C1AA7D" />
          </linearGradient>
          <linearGradient
            id="prefix__paint1_linear"
            x1={1.661}
            y1={32.422}
            x2={63.197}
            y2={32.422}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D1BB91" />
            <stop offset={0.726} stopColor="#DECEAE" />
            <stop offset={1} stopColor="#D1BB91" />
          </linearGradient>
          <linearGradient
            id="prefix__paint2_linear"
            x1={1.661}
            y1={50.905}
            x2={63.197}
            y2={50.905}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C1AA7D" />
            <stop offset={0.263} stopColor="#DECCA8" />
            <stop offset={0.721} stopColor="#DECCA8" />
            <stop offset={1} stopColor="#C1AA7D" />
          </linearGradient>
          <clipPath id="prefix__clip0">
            <path fill="#fff" d="M0 0h374v74H0z" />
          </clipPath>
          <pattern
            id="prefix__pattern0"
            patternContentUnits="objectBoundingBox"
            width={1}
            height={1}
          >
            <use xlinkHref="#prefix__image0" transform="scale(.00164 .00694)" />
          </pattern>
        </defs>
      </svg>
    </>
  );
}
